import React, { Component } from 'react';
import '../MuhammadSaw/saw.css';
import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { AddFormItemLabel } from 'utils';
const FormItem = Form.Item;

const LinkInputStyled = styled(Input)`
  .ant-input-wrapper {
    height: 40px !important;
    font-weight: 400;
    font-size: "16px";

    .ant-input-group-addon {
      border-radius: 10px 0 0 10px !important;
      font-size: 16px;
      padding-top: 4px;
    }

    .ant-input-affix-wrapper {
      border-radius: 0 10px 10px 0;
      height: 40px;
      overflow: hidden;

      .ant-input {
        font-size: 16px;
        font-weight: 400;
        padding-top: 3px;
      }
    }
  }
`;

const checkURL = (url, id) => {
  return fetch(`projects/check_url`, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify({ project: { url, project_id: id } }),
  }).then((result) => {
    if (!result.url) {
      return Promise.resolve();
    } else {
      return Promise.reject('Dieser Link ist leider schon vergeben.');
    }
  });
};
export default class LinkInput extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    form: PropTypes.object,
  };
  //state = {
  //  link: '',
  //};
  handleChangeLink = (e) => {
    this.setState({ link: e.target.defaultValue });
  };

  componentDidUpdate() {
    const { form } = this.props;
    if (form) {
      form.validateFields(["url"]);
    }
  }

  render() {
    //const { link } = this.state;
    const { projectId } = this.props;
    return (
      <div>
        <FormItem
          name="url"
          label={
            <AddFormItemLabel>
              Persönlicher Link
            </AddFormItemLabel>
          }
          required={false}
          hasFeedback
          extra={
            <>
              <p className="project-link remark">
                Verwende keine Sonderzeichen.
              </p>
            </>
          }
          rules={[
            {
              required: true,
              message: 'Projektlink fehlt!',
            },
            {
              min: 4,
              message: 'Bitte gebe mindestens 4 Zeichen ein.',
            },
            () => ({
              validator: (_, value) => {
                if (/^[a-zA-Z0-9]+$/.test(value)) {
                  return checkURL(value, projectId);
                }
                return Promise.reject('Sonderzeichen sind nicht erlaubt.');
              },
            }),
          ]}
        >
          <LinkInputStyled
            placeholder="spendenFuerMeinProjekt"
            maxLength={15}
            className="ant-input-group .ant-input"
            addonBefore={
              process.env.NODE_ENV === 'production'
                ? 'commonsplace.de/project/'
                : 'localhost:3001/project/'
            }
          />
        </FormItem>
      </div>
    );
  }
}
